<section class="vp-benefits-section">
  <style>
    .vp-benefits-section {
      font-family: Roboto, sans-serif;
      padding: 60px 20px;
      background: #fff;
      overflow: hidden;
    }

    .vp-title {
      text-align: center;
      font-size: 2rem;
      font-weight: 900;
      margin-bottom: 40px;
    }

    /* MAIN LAYOUT */
    .vp-layout {
      display: grid;
      grid-template-columns: 1fr auto 1fr;
      align-items: center;
      gap: 40px;
      max-width: 1350px;
      margin: auto;
    }

    /* IMAGES (SLIGHTLY BIGGER) */
    .vp-side-img img {
      width: 100%;
      max-width: 400px; /* 🔥 increased */
      display: block;
      animation: floatImage 5s ease-in-out infinite;
    }

    @keyframes floatImage {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(0px); }
    }

    /* ARROW STACK */
    .vp-arrow-wrapper {
      max-width: 500px; /* 🔥 reduced arrow length */
      margin: auto;
      display: flex;
      flex-direction: column;
      gap: 18px;
    }

    .vp-arrow {
      display: flex;
      align-items: center;
      opacity: 0;
      transform: translateX(-80px);
      animation: slideIn 0.9s ease forwards;
    }

    .vp-arrow:nth-child(1) { animation-delay: 3s; }
    .vp-arrow:nth-child(2) { animation-delay: 3.3s; }
    .vp-arrow:nth-child(3) { animation-delay: 3.9s; }

    @keyframes slideIn {
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    /* ARROW BODY */
    .vp-arrow-body {
      background: white;
      color:  #d32f2f;;
      padding: 14px 20px;
      display: flex;
      align-items: center;
     
      flex: 1;
      box-shadow: 0 6px 14px rgba(0,0,0,0.15);
      border-radius: 14px 0 0 14px;
      margin-right: -1px;
      transition: all 0.35s ease;
    }

    /* ULTRA SHARP ARROW HEAD */
    .vp-arrow-head {
      width: 0;
      height: 0;
      border-top: 14px solid transparent;
      border-bottom: 14px solid transparent;
      border-left: 55px solid #d32f2f;
      transition: all 0.35s ease;
    }

    /* ICON */
    .vp-icon {
      font-size: 1.6rem;
      margin-right: 14px;
      min-width: 32px;
    }

    /* NUMBER */
    .vp-number {
      margin-left: auto;
      font-size: 2.6rem;
      font-weight: 900;
      opacity: 0.25;
      line-height: 1;
    }

    /* 🔥 HOVER EFFECTS */
    .vp-arrow:hover .vp-arrow-body {
      transform: translateX(10px);
      box-shadow: 0 10px 25px rgba(211,47,47,0.45);
    }

    .vp-arrow:hover .vp-arrow-head {
      transform: translateX(10px);
      filter: drop-shadow(0 0 10px rgba(211,47,47,0.8));
    }

    /* MOBILE */
    @media (max-width: 992px) {
      .vp-layout {
        grid-template-columns: 1fr;
      }

      .vp-side-img {
        display: none;
      }

      .vp-arrow-head {
        display: none;
      }

      .vp-arrow-body {
        border-radius: 10px;
      }
    }
  </style>

  <h2 class="vp-title">The Value We Deliver</h2>

  <div class="vp-layout">

    <!-- LEFT IMAGE -->
    <div class="vp-side-img">
      <img src="assets/images/beforestress.png" alt="Before stress">
    </div>

    <!-- ARROWS -->
    <div class="vp-arrow-wrapper">

      <div class="vp-arrow">
        <div class="vp-arrow-body">
          <i class="fas fa-layer-group vp-icon"></i>
          No need to start from zero.
          <!--<div class="vp-number">1</div>-->
        </div>
        <div class="vp-arrow-head"></div>
      </div>

      <div class="vp-arrow">
        <div class="vp-arrow-body">
          <i class="fas fa-file-alt vp-icon"></i>
          Professional format ready for client or site engineer.
          <!--<div class="vp-number">2</div>-->
        </div>
        <div class="vp-arrow-head"></div>
      </div>

      <div class="vp-arrow">
        <div class="vp-arrow-body">
          <i class="fas fa-drafting-compass vp-icon"></i>
          Designed by experienced consultants.
          <!--<div class="vp-number">3</div>-->
        </div>
        <div class="vp-arrow-head"></div>
      </div>

    </div>

    <!-- RIGHT IMAGE -->
    <div class="vp-side-img">
      <img src="assets/images/afterrelax.png" alt="After relax">
    </div>

  </div>
</section>   
